export var DocumentFileType;
(function (DocumentFileType) {
    DocumentFileType["File"] = "file";
    DocumentFileType["Html"] = "html";
    DocumentFileType["Link"] = "link";
})(DocumentFileType || (DocumentFileType = {}));
//# sourceMappingURL=document-file-type.js.map